import { render, staticRenderFns } from "./DashboardRefundsPaymentsList.vue?vue&type=template&id=7e17d361&"
import script from "./DashboardRefundsPaymentsList.vue?vue&type=script&lang=js&"
export * from "./DashboardRefundsPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports